
import { useState } from 'react';

export default function Gallery() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'Tất cả', icon: 'ri-image-line' },
    { id: 'oahu', name: 'Oahu', icon: 'ri-building-line' },
    { id: 'bigisland', name: 'Đảo Lớn', icon: 'ri-fire-line' },
    { id: 'maui', name: 'Maui', icon: 'ri-road-map-line' }
  ];

  const gallery = [
    {
      title: 'Honolulu Skyline',
      category: 'oahu',
      image: 'https://public.readdy.ai/ai/img_res/4a473e5acee931df028de632fc1f613b.jpg'
    },
    {
      title: 'Waikiki Beach Skyline',
      category: 'oahu',
      image: 'https://readdy.ai/api/search-image?query=Iconic%20Waikiki%20Beach%20skyline%20panorama%20with%20luxury%20hotels%2C%20high-rise%20buildings%20along%20beachfront%2C%20Diamond%20Head%20crater%2C%20crystal%20turquoise%20ocean%2C%20white%20sand%20beach%2C%20palm%20trees%2C%20sunset%20glow%2C%20professional%20travel%20photography%2C%20simple%20beach%20skyline%20background&width=800&height=600&seq=gallery-waikiki-skyline-2&orientation=landscape'
    },
    {
      title: 'Waikiki Beach',
      category: 'oahu',
      image: 'https://readdy.ai/api/search-image?query=Stunning%20Waikiki%20Beach%20panorama%20in%20Oahu%20Hawaii%20with%20Diamond%20Head%20mountain%20backdrop%2C%20crystal%20turquoise%20ocean%2C%20white%20sand%20beach%2C%20palm%20trees%2C%20surfers%2C%20luxury%20hotels%2C%20golden%20sunset%2C%20tropical%20paradise%2C%20professional%20travel%20photography%2C%20simple%20beach%20background&width=800&height=600&seq=gallery-waikiki-3&orientation=landscape'
    },
    {
      title: 'Trân Châu Cảng',
      category: 'oahu',
      image: 'https://readdy.ai/api/search-image?query=Pearl%20Harbor%20USS%20Arizona%20Memorial%20in%20Hawaii%2C%20white%20memorial%20structure%20over%20water%2C%20American%20flags%2C%20naval%20ships%2C%20historical%20World%20War%20II%20site%2C%20solemn%20atmosphere%2C%20clear%20blue%20sky%2C%20professional%20documentary%20photography%2C%20simple%20memorial%20background&width=800&height=600&seq=gallery-pearl-4&orientation=landscape'
    },
    {
      title: 'Trung tâm Polynesian',
      category: 'oahu',
      image: 'https://readdy.ai/api/search-image?query=Polynesian%20Cultural%20Center%20Hawaii%20with%20traditional%20dancers%20in%20vibrant%20costumes%2C%20fire%20dance%20performance%2C%20tropical%20setting%2C%20cultural%20show%2C%20authentic%20luau%2C%20evening%20lighting%2C%20professional%20event%20photography%2C%20simple%20tropical%20stage%20background&width=800&height=600&seq=gallery-poly-5&orientation=landscape'
    },
    {
      title: 'Vịnh Hanauma',
      category: 'oahu',
      image: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Hanauma%20Bay%20Hawaii%2C%20crystal%20clear%20turquoise%20water%2C%20coral%20reef%20visible%20underwater%2C%20curved%20beach%2C%20snorkelers%2C%20tropical%20fish%2C%20volcanic%20crater%20bay%2C%20nature%20reserve%2C%20professional%20travel%20photography%2C%20simple%20ocean%20background&width=800&height=600&seq=gallery-hanauma-6&orientation=landscape'
    },
    {
      title: 'Núi lửa hoạt động',
      category: 'bigisland',
      image: 'https://readdy.ai/api/search-image?query=Active%20volcano%20Big%20Island%20Hawaii%20with%20glowing%20red%20lava%20flows%2C%20volcanic%20crater%2C%20molten%20lava%20rivers%2C%20steam%20rising%2C%20dramatic%20volcanic%20landscape%2C%20night%20photography%20with%20lava%20glow%2C%20geological%20wonder%2C%20professional%20nature%20photography%2C%20simple%20volcanic%20background&width=800&height=600&seq=gallery-volcano-7&orientation=landscape'
    },
    {
      title: 'Dung nham đỏ rực',
      category: 'bigisland',
      image: 'https://readdy.ai/api/search-image?query=Flowing%20red%20hot%20lava%20on%20Big%20Island%20Hawaii%2C%20molten%20lava%20streams%2C%20glowing%20orange%20lava%2C%20volcanic%20activity%2C%20dramatic%20geological%20formation%2C%20night%20photography%2C%20intense%20heat%20glow%2C%20professional%20nature%20photography%2C%20simple%20lava%20background&width=800&height=600&seq=gallery-lava-8&orientation=landscape'
    },
    {
      title: 'Bãi cát đen',
      category: 'bigisland',
      image: 'https://readdy.ai/api/search-image?query=Black%20sand%20beach%20Big%20Island%20Hawaii%20with%20volcanic%20black%20sand%2C%20green%20sea%20turtles%20on%20shore%2C%20turquoise%20ocean%20waves%2C%20palm%20trees%2C%20dramatic%20contrast%2C%20unique%20natural%20phenomenon%2C%20professional%20travel%20photography%2C%20simple%20beach%20background&width=800&height=600&seq=gallery-blacksand-9&orientation=landscape'
    },
    {
      title: 'Thác Akaka',
      category: 'bigisland',
      image: 'https://readdy.ai/api/search-image?query=Akaka%20Falls%20waterfall%20Big%20Island%20Hawaii%2C%20tall%20cascading%20waterfall%20through%20lush%20tropical%20rainforest%2C%20misty%20spray%2C%20verdant%20jungle%20vegetation%2C%20dramatic%20drop%2C%20professional%20nature%20photography%2C%20simple%20forest%20background&width=800&height=600&seq=gallery-akaka-10&orientation=landscape'
    },
    {
      title: 'Đường đến Hana',
      category: 'maui',
      image: 'https://readdy.ai/api/search-image?query=Scenic%20Road%20to%20Hana%20Maui%20Hawaii%2C%20winding%20coastal%20highway%2C%20lush%20tropical%20rainforest%2C%20waterfalls%20along%20road%2C%20dramatic%20ocean%20views%2C%20narrow%20bridges%2C%20verdant%20jungle%2C%20misty%20mountains%2C%20professional%20travel%20photography%2C%20simple%20road%20background&width=800&height=600&seq=gallery-hana-11&orientation=landscape'
    },
    {
      title: 'Maui Big Beach',
      category: 'maui',
      image: 'https://readdy.ai/api/search-image?query=Big%20Beach%20Makena%20Maui%20Hawaii%2C%20wide%20white%20sand%20beach%2C%20crystal%20clear%20turquoise%20water%2C%20palm%20trees%2C%20golden%20sunset%2C%20romantic%20tropical%20paradise%2C%20professional%20beach%20photography%2C%20simple%20ocean%20background&width=800&height=600&seq=gallery-bigbeach-12&orientation=landscape'
    },
    {
      title: 'Haleakalā Sunrise',
      category: 'maui',
      image: 'https://readdy.ai/api/search-image?query=Haleakala%20volcano%20crater%20sunrise%20Maui%20Hawaii%2C%20dramatic%20volcanic%20landscape%20above%20clouds%2C%20golden%20sunrise%20light%2C%20volcanic%20crater%2C%20misty%20clouds%20below%2C%20spectacular%20mountain%20vista%2C%20professional%20landscape%20photography%2C%20simple%20mountain%20background&width=800&height=600&seq=gallery-haleakala-13&orientation=landscape'
    },
    {
      title: 'Lahaina Town',
      category: 'maui',
      image: 'https://readdy.ai/api/search-image?query=Historic%20Lahaina%20town%20Maui%20Hawaii%2C%20charming%20waterfront%2C%20old%20whaling%20village%2C%20palm%20trees%2C%20ocean%20view%2C%20colorful%20buildings%2C%20tropical%20atmosphere%2C%20professional%20travel%20photography%2C%20simple%20coastal%20town%20background&width=800&height=600&seq=gallery-lahaina-14&orientation=landscape'
    }
  ];

  const filteredGallery = selectedCategory === 'all' 
    ? gallery 
    : gallery.filter(item => item.category === selectedCategory);

  return (
    <section id="gallery" className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Thư viện <span className="text-blue-600">Hawaii</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Khám phá vẻ đẹp tuyệt vời của quần đảo Hawaii qua hình ảnh
          </p>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-gradient-to-r from-blue-600 to-teal-500 text-white shadow-lg scale-105'
                    : 'bg-white text-gray-700 hover:bg-blue-50 shadow-md'
                }`}
              >
                <i className={`${category.icon} mr-2`}></i>
                {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {filteredGallery.map((item, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-xl font-bold">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="#video"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-teal-500 text-white rounded-full font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Xem album & video
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
